export function accountAllowedRoute(to,roles) {
    if (!to.matched) return false; // should never enter

    let allowed = true;

    for (const route of to.matched.slice().reverse()) {
      // check if route is hidden for some roles (hidden is a priority)
      if (route.meta.hiddenFor && route.meta.hiddenFor.length) {
        let intersection = route.meta.hiddenFor.filter(allowedFilterCB, {roles});
        if (intersection.length > 0) {
          allowed = false;
          return;
        }
      }
      // check if route is allowed only for some roles
      if (route.meta.allowedFor && route.meta.allowedFor.length) {
        let intersection = route.meta.allowedFor.filter(allowedFilterCB, {roles});
        if (intersection.length <= 0) {
          allowed = false;
          return;
        }
      }
    }

    return allowed;
}

export function accountFilteredMenu(nav,roles) {
    let items = nav;
    let filtered = [];

    for (let i = 0; i < items.length; ++i) {
        // if  menu item has hiddenFor directive check if it is allowed
        if(items[i].children && items[i].children.length > 0){
          items[i].children = accountFilteredMenuChildren(roles, items[i]);
        }
        if(typeof items[i].hiddenFor !== 'undefined')
        {
            let intersection = items[i].hiddenFor.filter(x => roles.includes(x));

            if(intersection.length <= 0)
            {
                if(typeof items[i].allowedFor !== 'undefined')
                {
                    let allowedIntersection = items[i].allowedFor.filter(x => roles.includes(x));

                    if(allowedIntersection.length > 0)
                        filtered.push( items[i] );
                }
                else
                    filtered.push( items[i] );
            }
        }
        // if  menu item has roles check if it is allowed
        else if(typeof items[i].allowedFor !== 'undefined')
        {
            let rolesIntersection = items[i].allowedFor.filter(x => roles.includes(x));

            if(rolesIntersection.length > 0)
                filtered.push( items[i] );
        }
        else
        {
            filtered.push( items[i] );
        }
    }
    return filtered;
}

function allowedFilterCB(x){
  if(Array.isArray(x)){
    let and_cond = true;
    x.forEach(y => {
      if(and_cond && !this.roles.includes(y)){
        and_cond = false;
      }
    });
    return and_cond;
  }else return this.roles.includes(x);
}

function accountFilteredMenuChildren(roles, item){
  let nav_children = [];
  item.children.forEach(element => {
    if(typeof element.hiddenFor !== 'undefined'){
      if(element.hiddenFor.filter(x => roles.includes(x)).length == 0){
        if(typeof element.allowedFor !== 'undefined'){
          if(element.allowedFor.filter(x => roles.includes(x)).length > 0){
            nav_children.push(element);
          }
        }else nav_children.push(element);
      }
    }else{
      if(typeof element.allowedFor !== 'undefined'){
        if(element.allowedFor.filter(x => roles.includes(x)).length > 0){
          nav_children.push(element);
        }
      }else nav_children.push(element);
    }
  })
  return nav_children;
}